import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CloseIcon from '@mui/icons-material/Close';
import {
    Dialog,
    Grid,
    IconButton,
    Input,
    Stack,
    Typography
} from '@mui/material';
import { withStyles } from '@mui/styles';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';

const styles = {
    dialogPaper: {
        minHeight: '45vh',
        maxHeight: '45vh',
    },
};

function ProjectInfoModal({ handleClose, open, project }) {
    ProjectInfoModal.propTypes = {
        open: PropTypes.func,
        handleClose: PropTypes.func,
        project: PropTypes.any,
    };
    const { i18n } = useTranslation();
    return (
        <div>
            <Dialog
                fullWidth="true"
                maxWidth="md"
                maxHeight="md"
                open={open}
                onClose={handleClose}
                scroll="body"
                // classes={{ paper: classes.dialogPaper }}
            >
                <Grid
                    container
                    sx={{ padding: '30px' }}
                >
                    <Grid
                        container
                        justifyContent="end"
                        xs={12}
                    >
                        <IconButton onClick={handleClose}>
                            <CloseIcon />
                        </IconButton>
                    </Grid>
                    <Grid
                        container
                        justifyContent="center"
                        xs={12}
                    >
                        <div
                            style={{
                                padding: '4px',
                                backgroundColor: '#CBE2F1',
                                borderRadius: '4px',
                                display: 'flex',
                                justifyContent: 'center',
                                width: 'fit-content',
                                marginRight: '10px',
                                marginBottom: '30px',
                            }}
                        >
                            <AccountTreeIcon
                                fontSize="large"
                                sx={{ color: '#FFFFFF' }}
                            />
                        </div>
                        <Typography
                            fontSize={25}
                            style={{ fontWeight: 'bolder' }}
                        >
                            {project.title}
                        </Typography>
                    </Grid>
                    <Grid
                        item
                        xs={12}
                    >
                        <Stack>
                            <Input
                                disabled
                                defaultValue={project.title}
                            />
                            <Input
                                disabled
                                defaultValue={project.createdAt}
                            />
                            <Input
                                disabled
                                defaultValue={`${project.missionId.length}` + i18n.t(' missions')}
                            />
                        </Stack>
                    </Grid>
                </Grid>
            </Dialog>
        </div>
    );
}

export default withStyles(styles)(ProjectInfoModal);
